// extracted by mini-css-extract-plugin
module.exports = {"fieldinfo":"FieldInfo_fieldinfo__2dC-H"};